function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Counters, QueryStrings } from '../infrastructure/const';
import UrlUtils from './url-utils';
// import Logger from '../../../../wdh-logger/wdh-logger';

/**
 * Utillity manager for products
 * @memberOf module:wdh-feature-b2b
 */
var ProductsUtils = /*#__PURE__*/function () {
  function ProductsUtils() {
    _classCallCheck(this, ProductsUtils);
  }
  return _createClass(ProductsUtils, null, [{
    key: "updateQuantity",
    value:
    /**
     * Finds the product in the product list, and update the product quantity
     * Also check for min/max quantity, before update
     * @param {Object} products         Product list to update
     * @param {String} productId        Id of the product to update
     * @param {Number} quantityChange   Quantity change to update
     */
    function updateQuantity(products, productId, quantityChange) {
      var product = products.find(function (x) {
        return x.id === productId;
      });
      if (product) {
        product.minQuantity = Counters.MinItems; // TODO: Get real data
        product.maxQuantity = Counters.MaxItems; // TODO: Get real data
        var newQuantity = product.quantity + quantityChange;
        if (newQuantity >= product.minQuantity && newQuantity <= product.maxQuantity) {
          product.quantity = newQuantity;
        }
      }
    }

    /**
     * Reset the quantity for the product list
     * @param {Object} productList  Product list to show in the product list component
     * @returns {Bool}              True if the product list has been updated, else false
     */
  }, {
    key: "resetProductQuantities",
    value: function resetProductQuantities(productList) {
      var hasUpdates = false;
      for (var i = 0; i < productList.length; i += 1) {
        if (productList[i].quantity !== 0) {
          productList[i].quantity = 0;
          hasUpdates = true;
        }
      }
      return hasUpdates;
    }

    /**
     * Add/update a product to the product list
     * If product already exists, update the Quantity instead of adding
     * If Quantity is 0 for a product, remove it from the list
     * @param {Object} cartProductList    List of products
     * @param {String} product            Product to add
     * @param {Number} change             Quantity to add
     * @param {Boolean} removeItem           Remove item from productList if true
     * @returns {Boolean}                    True if there are items in the product list, else false
     */
  }, {
    key: "addToCartProductList",
    value: function addToCartProductList(cartProductList, product, change) {
      var removeItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var index = -1;
      if (Object.keys(cartProductList).length > 0) {
        index = cartProductList.findIndex(function (listItem) {
          return listItem.id === product.id;
        });
      }
      if (index >= 0) {
        cartProductList[index].quantity += change;
        if (cartProductList[index].quantity === 0 && removeItem) {
          cartProductList.splice(index, 1);
        }
      } else if (change > 0) {
        product.quantity += change;
        cartProductList.push(product);
      }
    }
  }, {
    key: "getWithClearedQuantities",
    value: function getWithClearedQuantities(productList) {
      var productListCopy = JSON.parse(JSON.stringify(productList));
      productListCopy.forEach(function (product) {
        product.quantity = 0;
      });
      return productListCopy;
    }
  }, {
    key: "setPreviousQuantity",
    value: function setPreviousQuantity(newProducts, previousProducts) {
      newProducts.forEach(function (newProduct) {
        var previousProduct = previousProducts.find(function (x) {
          return x.id === newProduct.id;
        });
        if (previousProduct) {
          newProduct.quantity = previousProduct.quantity;
        } else {
          newProduct.quantity = 0;
        }
      });
      return newProducts;
    }
  }, {
    key: "fillMissingImages",
    value: function fillMissingImages(products) {
      var _this = this;
      products.forEach(function (product) {
        product.imageUrl = _this.fillMissingImage(product.imageUrl);
      });
      return products;
    }
  }, {
    key: "fillMissingImage",
    value: function fillMissingImage(imageUrl) {
      if (!imageUrl) {
        return 'https://wdhimages.azureedge.net/images-uat/missing.png';
      }
      return imageUrl;
    }

    // if an image is not found (404), replace it with our default missing image
  }, {
    key: "fillImageNotFound",
    value: function fillImageNotFound(event) {
      event.target.src = 'https://wdhimages.azureedge.net/images-uat/missing.png';
    }
  }, {
    key: "extendArgsWithCategoryId",
    value: function extendArgsWithCategoryId(product, args) {
      var categoryId = UrlUtils.getParameterNumberByName(QueryStrings.CATEGORY_ID);
      if (!Number.isNaN(categoryId)) {
        args[QueryStrings.CATEGORY_ID] = categoryId;
      }
      if (!Number.isNaN(product.categoryId)) {
        args[QueryStrings.CATEGORY_ID] = product.categoryId;
      }
      return args;
    }
  }]);
}();
export default ProductsUtils;